export function InvoiceUpdateUnitCostCtrl ($uibModalInstance, $stateParams, $scope, gridAPI, workshopAPI, item) {

  $scope.item  = item;
  $scope.item.new_unit_cost = $scope.item.unit_cost

  $scope.save = function () {
    $uibModalInstance.close({
      item : $scope.item
    });
  };

  $scope.cancel = $uibModalInstance.dismiss;
}